<template>
  <div class="banner">
    <swiper
      :autoplay="{
        delay: 3000,
        disableOnInteraction: false,
      }"
      :loop="true"
      :modules="modules"
      :slides-per-view="1"
      dir="rtl"
      space-between="0"
      class="swip"
    >
      <swiper-slide>
        <div class="parent">
          <img
            v-if="navigationOptions || navigationOptions1 || navigationOptions2"
            src="@/assets/3boookmokup.jpg"
            class="responsive-image sd"
            alt=""
          />
          <img
            v-if="navigationOptions3"
            src="@/assets/3boookmokup1.jpg"
            class="responsive-image sd"
            alt=""
          />
          <div class="cont text-center" dir="rtl">
            <h3><span>ميزابووك</span></h3>
            <p class="hint">
              هو متجر متخصص في تقديم مجموعة متنوعة من الكتب التي تلبي مختلف
              الاهتمامات، بما في ذلك الروايات، الكتب الدينية، الكتب النفسية،
              بالإضافة إلى العديد من المجالات الأدبية والثقافية الأخرى. هدفنا هو
              إثراء معرفتك وتقديم أفضل الإصدارات للقراء العرب.
            </p>
            <div
              class="social d-flex justify-center mt-10"
              dir="ltr"
              style="gap: 20px"
            >
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 50px; height: 50px"
              >
                <a
                  href="https://web.facebook.com/profile.php?id=61566811787758"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="50px"
                    fill="#000000"
                    viewBox="0 0 32 32"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <title>facebook</title>
                      <path
                        d="M30.996 16.091c-0.001-8.281-6.714-14.994-14.996-14.994s-14.996 6.714-14.996 14.996c0 7.455 5.44 13.639 12.566 14.8l0.086 0.012v-10.478h-3.808v-4.336h3.808v-3.302c-0.019-0.167-0.029-0.361-0.029-0.557 0-2.923 2.37-5.293 5.293-5.293 0.141 0 0.281 0.006 0.42 0.016l-0.018-0.001c1.199 0.017 2.509 0.123 3.491 0.312l-0.134-0.019v3.69h-1.892c-0.086-0.012-0.185-0.019-0.285-0.019-1.197 0-2.168 0.97-2.168 2.168 0 0.068 0.003 0.150 0.009 0.202l-0.001-0.009v2.812h4.159l-0.665 4.336h-3.494v10.478c7.213-1.174 12.653-7.509 12.654-14.814v-0z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </span>
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 50px; height: 50px"
              >
                <a
                  href="https://www.instagram.com/mizabook/"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="50px"
                    fill="#000000"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M20.445 5h-8.891A6.559 6.559 0 0 0 5 11.554v8.891A6.559 6.559 0 0 0 11.554 27h8.891a6.56 6.56 0 0 0 6.554-6.555v-8.891A6.557 6.557 0 0 0 20.445 5zm4.342 15.445a4.343 4.343 0 0 1-4.342 4.342h-8.891a4.341 4.341 0 0 1-4.341-4.342v-8.891a4.34 4.34 0 0 1 4.341-4.341h8.891a4.342 4.342 0 0 1 4.341 4.341l.001 8.891z"
                      ></path>
                      <path
                        d="M16 10.312c-3.138 0-5.688 2.551-5.688 5.688s2.551 5.688 5.688 5.688 5.688-2.551 5.688-5.688-2.55-5.688-5.688-5.688zm0 9.163a3.475 3.475 0 1 1-.001-6.95 3.475 3.475 0 0 1 .001 6.95zM21.7 8.991a1.363 1.363 0 1 1-1.364 1.364c0-.752.51-1.364 1.364-1.364z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </span>
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 50px; height: 50px"
              >
                <a
                  href="https://www.tiktok.com/@mizabook"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="50px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="#000000"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <title>tiktok_fill</title>
                      <g
                        id="页面-1"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Brand"
                          transform="translate(-720.000000, -48.000000)"
                        >
                          <g
                            id="tiktok_fill"
                            transform="translate(720.000000, 48.000000)"
                          >
                            <path
                              d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590250 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7507139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7507139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118250,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z"
                              id="MingCute"
                              fill-rule="nonzero"
                            ></path>
                            <path
                              d="M14,2 C15.1046,2 16,2.89543 16,4 C16,5.44733 17.03,6.6618 18.3984,6.93991 C19.4808,7.15992 20.1799,8.21575 19.9599,9.29819 C19.7399,10.3806 18.6841,11.0798 17.6016,10.8598 C17.0406,10.7457 16.5037,10.5646 16,10.3252 L16,16 C16,19.3137 13.3137,22 10,22 C6.68629,22 4,19.3137 4,16 C4,13.2015 5.91407,10.8551 8.50148,10.1891 C9.57119,9.91382 10.6616,10.5578 10.9369,11.6275 C11.2122,12.6972 10.5682,13.7876 9.49852,14.0629 C8.65047,14.285 8,15.0708 8,16 C8,17.1046 8.89543,18 10,18 C11.1046,18 12,17.1046 12,16 L12,4 C12,2.89543 12.8954,2 14,2 Z"
                              id="路径"
                              fill="#000000"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </span>
              <span
                class="facebook d-flex align-center justify-center"
                style="width: 50px; height: 50px"
              >
                <a
                  href="https://wa.link/aktzzb"
                  target="_blank"
                  class="social-icon"
                >
                  <svg
                    width="50px"
                    fill="#000000"
                    viewBox="-2 -2 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin"
                    class="jam jam-whatsapp"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M9.516.012C4.206.262.017 4.652.033 9.929a9.798 9.798 0 0 0 1.085 4.465L.06 19.495a.387.387 0 0 0 .47.453l5.034-1.184a9.981 9.981 0 0 0 4.284 1.032c5.427.083 9.951-4.195 10.12-9.58C20.15 4.441 15.501-.265 9.516.011zm6.007 15.367a7.784 7.784 0 0 1-5.52 2.27 7.77 7.77 0 0 1-3.474-.808l-.701-.347-3.087.726.65-3.131-.346-.672A7.62 7.62 0 0 1 2.197 9.9c0-2.07.812-4.017 2.286-5.48a7.85 7.85 0 0 1 5.52-2.271c2.086 0 4.046.806 5.52 2.27a7.672 7.672 0 0 1 2.287 5.48c0 2.052-.825 4.03-2.287 5.481z"
                      ></path>
                      <path
                        d="M14.842 12.045l-1.931-.55a.723.723 0 0 0-.713.186l-.472.478a.707.707 0 0 1-.765.16c-.913-.367-2.850-2.063-3.326-2.912a.694.694 0 0 1 .056-.774l.412-.53a.71.71 0 0 0 .089-.726L7.38 5.553a.723.723 0 0 0-1.125-.256c-.539.453-1.179 1.14-1.256 1.903-.137 1.343.443 3.036 2.637 5.07 2.550 2.349 4.566 2.66 5.887 2.341.75-.18 1.50-.903 1.727-1.494a.713.713 0 0 0-.408-1.072z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </span>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="parent">
          <img
            v-if="navigationOptions"
            @click="$router.push({ name: 'book_request' })"
            src="@/assets/pack.jpg"
            class="responsive-image"
            style="cursor: pointer"
            alt=""
          />
          <img
            v-if="navigationOptions1"
            @click="$router.push({ name: 'book_request' })"
            src="@/assets/pack1.jpg"
            class="responsive-image sd"
            style="cursor: pointer"
            alt=""
          />
          <img
            v-if="navigationOptions2"
            @click="$router.push({ name: 'book_request' })"
            src="@/assets/pack2.jpg"
            class="responsive-image sd"
            style="cursor: pointer"
            alt=""
          />
          <img
            v-if="navigationOptions3"
            @click="$router.push({ name: 'book_request' })"
            src="@/assets/pack3.jpg"
            class="responsive-image sd"
            style="cursor: pointer"
            alt=""
          />
        </div>
      </swiper-slide>

      <!-- Optional Swiper navigation buttons -->

      <!-- Optional Swiper pagination -->
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Pagination, Navigation, Scrollbar, Autoplay } from "swiper/modules"; // Correct module imports
import "swiper/swiper-bundle.css"; // Import swiper styles
import { ref, onMounted, computed } from "vue"; // Import ref and onMounted
export default {
  name: "UpperBanner",

  components: {
    Swiper,
    SwiperSlide,
  },

  setup() {
    const windowWidth = ref(window.innerWidth); // Reactive windowWidth

    const handleResize = () => {
      windowWidth.value = window.innerWidth; // Update the reactive width
    };

    // Add the resize listener when component is mounted
    onMounted(() => {
      window.addEventListener("resize", handleResize); // Add event listener for resizing
    });

    // Computed property for navigation options
    const navigationOptions = computed(() => {
      return windowWidth.value > 1627;
    });
    const navigationOptions1 = computed(() => {
      return windowWidth.value <= 1627 && windowWidth.value > 1207;
    });
    const navigationOptions2 = computed(() => {
      return windowWidth.value <= 1207 && windowWidth.value > 973;
    });
    const navigationOptions3 = computed(() => {
      return windowWidth.value <= 973;
    });
    return {
      modules: [Pagination, Navigation, Scrollbar, Autoplay], // Correct Swiper modules
      windowWidth, // Expose windowWidth
      navigationOptions, // Expose navigationOptions
      navigationOptions1,
      navigationOptions2,
      navigationOptions3,
    };
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 3000, // 3 seconds delay between slides
          disableOnInteraction: false, // Keeps autoplay running even after user interaction
        },
      },
    };
  },

  // Component options
};
</script>
<style lang="scss">
@import "swiper/swiper-bundle.css";
.responsive-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.banner {
  .parent {
    height: 1000px;
    position: relative;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .cont {
    position: absolute;
    left: 90px;
    top: 10px;
    width: 850px;
    color: rgb(68, 68, 68);
    margin-top: 0px;
    padding: 300px 20px 0 0;
    h3 {
      font-size: 50px;
      font-weight: 900;
      span {
        color: rgb(46, 92, 77);
      }
    }

    .hint {
      font-size: 40px;
      margin: 10px 0 20px;
    }
  }
}
.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  transition: transform 0.3s;
}

.social-icon:hover {
  transform: scale(1.2);
  cursor: pointer;
}
.swip {
  margin-top: -65px;
}
@media (max-width: 1669px) {
  .banner {
    .cont {
      width: 750px;
      h3 {
        font-size: 40px;
      }
      .hint {
        font-size: 35px;
      }
    }
  }
}
@media (max-width: 1530px) {
  .banner {
    .cont {
      width: 700px;
      h3 {
        font-size: 37px;
      }
      .hint {
        font-size: 33px;
      }
    }
  }
}
@media (max-width: 1430px) {
  .banner {
    .cont {
      width: 650px;
      left: 40px;
      h3 {
        font-size: 35px;
      }
      .hint {
        font-size: 30px;
      }
    }
  }
}
@media (max-width: 1231px) {
  .banner {
    .cont {
      width: 600px;
      left: 37px;
      top: 55px;
      h3 {
        font-size: 33px;
      }
      .hint {
        font-size: 28px;
      }
    }
  }
}
@media (max-width: 1126px) {
  .banner {
    .parent {
      height: 960px;
      .cont {
        width: 480px;
        left: 35px;
        top: 20px;
        h3 {
          font-size: 33px;
        }
        .hint {
          font-size: 28px;
        }
      }
    }
  }
}
@media (max-width: 872px) {
  .banner {
    .parent {
      height: 920px;
      .cont {
        width: 430px;
        left: 20px;
        top: 0px;
        h3 {
          font-size: 33px;
        }
        .hint {
          font-size: 28px;
        }
      }
    }
  }
}
@media (max-width: 738px) {
  .banner {
    .parent {
      height: 880px;
      .cont {
        width: 400px;
        left: 0px;
        top: -30px;
        h3 {
          font-size: 30px;
        }
        .hint {
          font-size: 26px;
        }
      }
    }
  }
}
@media (max-width: 653px) {
  .banner {
    .parent {
      height: 850px;
      .cont {
        width: 370px;
        left: 0px;
        top: -50px;
        h3 {
          font-size: 30px;
        }
        .hint {
          font-size: 25px;
        }
      }
    }
  }
}
@media (max-width: 587px) {
  .banner {
    .parent {
      height: 800px;
      .cont {
        width: 330px;
        left: 20px;
        top: -40px;
        h3 {
          font-size: 27px;
        }
        .hint {
          font-size: 22px;
        }
      }
    }
  }
}
@media (max-width: 549px) {
  .banner {
    .parent {
      height: 780px;
      .cont {
        width: 300px;
        left: 20px;
        top: -40px;
        h3 {
          font-size: 25px;
        }
        .hint {
          font-size: 20px;
        }
      }
    }
  }
}
@media (max-width: 483px) {
  .banner {
    .parent {
      height: 750px;
      .cont {
        width: 280px;
        left: 20px;
        top: -60px;
        h3 {
          font-size: 25px;
        }
        .hint {
          font-size: 20px;
        }
      }
    }
  }
}

@media (max-width: 441px) {
  .banner {
    .parent {
      height: 730px;
      .cont {
        width: 237px;
        left: 9px;
        top: -60px;
        h3 {
          span {
            font-size: 30px;
            font-weight: bold;
          }
          font-size: 25px;
        }
        .hint {
          font-size: 19px;
        }
      }
    }
  }
  .social {
    gap: none;
  }
  .social-icon {
    gap: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    transition: transform 0.3s;
  }
}
@media (max-width: 1323px) {
  .swip {
    margin-top: -110px;
  }
}
</style>
